import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { GetLightpointData } from "../hooks/middleware.js";
import { CountItems, SortItems, CountTotal } from "../hooks/chartMethods.js";

const ALL_CLASSES = ["A", "B", "C", "D", "E", "F", "G"];
const EFFICIENCY_COLORS = {
  A: "#66ff33",
  B: "#ccff33",
  C: "#ffff33",
  D: "#ffcc33",
  E: "#ff9933",
  F: "#ff6600",
  G: "#ff0000"
};

export default function TileEnergyClassPotential({ id }) {
  const { data, error } = GetLightpointData(id);
  const counts = CountItems(data, "lamprepenergyefficiencyclass");

  const filled = ALL_CLASSES.map(cls => {
    const item = counts.find(c => c.name === cls);
    return {
      name: cls,
      count: item ? item.count : 0
    };
  });

  const finalData = SortItems(filled, "lamprepenergyefficiencyclass");
  
  const totalCount = CountTotal(finalData, "count");

  if (error) return <p>Error loading data.</p>;
  if (!finalData) return <p>Loading Pie Chart...</p>;
  if (finalData.length === 0) return <p>No data found</p>;

  return (
    <div style={{ display: "flex", gap: "0rem" }}>
      {/* Table column */}
      <div style={{ minWidth: "200px" }}>
        {finalData.map((item, index) => {
          const color = EFFICIENCY_COLORS[item.name] || "#ccc"; // fallback grey
          return (
            <div key={item.name} className="table-row">
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: color,
                  marginRight: "0.5rem",
                  borderRadius: "2px"
                }}
              ></span>
              <span
                style={{
                  minWidth: "100px",
                  maxWidth: "100px",
                  display: "inline-block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
                title={item.name}
              >
                Klasse {item.name}
              </span>
              <span style={{ minWidth: "80px", textAlign: "right" }}>
                {((item.count / totalCount) * 100).toFixed(1)}%
              </span>
            </div>
          );
        })}
      </div>

      {/* Pie chart */}
      <div style={{ flex: 1, height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={finalData}
              dataKey="count"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={150}
              label={false}
            >
              {finalData.map((entry) => (
                <Cell
                  key={entry.name}
                  fill={EFFICIENCY_COLORS[entry.name] || "#ccc"}
                />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => [`${value}`, `Klasse ${props.payload.name}`]}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
